import { useQuery } from "@tanstack/react-query";
import { API_LOCATION } from "../apis";
import { QUERY_KEY } from "../keys";

export const useGetLocation = <T>(params: { [key: string]: string }) => {
    const { data, isLoading } = useQuery({
        queryKey: [QUERY_KEY.GET_LOCATION_INFO],
        queryFn: () => API_LOCATION.getMapInfo<T>(params),
    });

    return { data, isLoading };
};
